import 'whatwg-fetch'
import { languageChange } from './state/Login';
import { errorModal } from './state/Error';
import { sessionExpired } from './state/Login';
import { getAccessToken } from './auth/accessToken';

function mustGetEnv(name) {
    const value = process.env[name];
    if (value === undefined || value === '') {
        throw new Error(`Missing required environment variable ${name}`);
    }
    return value;
}

const baseUrl = mustGetEnv('REACT_APP_API_URL');
const apiKey = mustGetEnv('REACT_APP_API_KEY');

export const url = `${baseUrl}?apiKey=${apiKey}`;
export const signUrls = {
    idCard: 'https://sign.olerex.ee/sign/idcard',
    mobileId: 'https://sign.olerex.ee/sign/mobileid',
    smartId: 'https://sign.olerex.ee/sign/smartid'
};


const request = (dispatch, url, body, successCallback, errorCallback, ignoreErrorModal = false, method = 'POST') => {
    window.fetch(url,
        {
            method,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: method === 'GET' ? undefined : JSON.stringify(body)
        })
        .then(response => response.json())
        .then(data => {
            if (data && data.records && data.records.tokenExpired === 1) {
                dispatch(sessionExpired());
            } else {
                if (data && data.records && data.records.statusCode !== undefined && data.records.statusCode !== 200) {
                    if (data.status && !(data.status.act === "olerexweb.business.cards" || data.status.act === "olerexweb.business.manage" || data.status.act === 'olerexweb.validate')) {
                        if (!ignoreErrorModal) {
                            dispatch(errorModal(true));
                        }
                        if (errorCallback) {
                            errorCallback(data);
                        }
                        return;
                    }
                }
                if (data && data.records && data.records.language) {
                    dispatch(languageChange(data.records.language));
                }
                if (successCallback) {
                    successCallback(data);
                }
            }
        })
        .catch(error => {
            if (!ignoreErrorModal) {
                dispatch(errorModal(true));
            }
            if (errorCallback) {
                errorCallback(error);
            } else {
                console.error('Unhandled request error', error);
            }
        });
};

// Authenticated calls source the token from the single in-memory owner instead
// of relying on each caller to thread it through the body. The owner mirrors
// redux `login.token` (see index.js), so the injected value is identical to what
// callers pass today — this is behaviour-preserving; it just makes request() the
// one place the token is attached, ready for the planned refresh interceptor.
const authedRequest = (dispatch, requestUrl, body, success, error, ignoreErrorModal = false, method = 'POST') =>
    request(dispatch, requestUrl, body ? { ...body, token: getAccessToken() } : body, success, error, ignoreErrorModal, method);

export const authRequest = (dispatch, body, success, error) => request(dispatch, `${url}&act=olerexweb.auth`, body, success, error);
export const getActiveSessionsRequest = (dispatch, body, success, error) => request(dispatch, `${url}&act=olerexweb.getActiveSessions&token=${getAccessToken()}&userId=${body.userId || ''}&accNr=${body.accNr || ''}`, body, success, error, false, 'GET');

export const inviteRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.virtualFamilyInvite`, body, success, error);
export const updateUserData = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.private.updateUserData`, body, success, error);

export const businessDashboardRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.business.dashboard`, body, success, error);
export const businessCardsRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.business.cards`, body, success, error);
export const validateAddCardRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.validate`, body, success, error);
export const businessInvoicesRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.business.invoices`, body, success, error);
export const businessBanklinksRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.business.banklink`, body, success, error);
export const businessTransactionsRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.business.transactions`, body, success, error);
export const businessManageRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.business.manage`, body, success, error);
export const businessVirtualFamilyRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.business.virtualfamily`, body, success, error);
export const businessWholeSaleRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.wholeSale`, body, success, error);

export const privateDashboardRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.private.dashboard`, body, success, error);
export const privateUpdateUserDataRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.private.updateUserData`, body, success, error, body.ignoreErrorModal);
export const privateTransactionsRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.private.transactions`, body, success, error);
export const privateVouchersRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.private.vouchers`, body, success, error, body.ignoreErrorModal);
export const privateInvoicesRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.business.invoices`, body, success, error); //business.invoices not private.invoices

export const privateElectricityRequest = (dispatch, body, success, error) => authedRequest(dispatch, `${url}&act=olerexweb.private.electricity`, body, success, error);

export const getTicketsRequest = (dispatch, personalCode, success, error) => request(dispatch, `${url}&act=olerexweb.travel.getTickets&personalCode=${personalCode}`, null, success, error);

const gatewayBaseUrl = process.env.REACT_APP_GATEWAY_URL || 'https://gateway.olerex.ee';
const ssoBaseUrl = process.env.REACT_APP_SSO_URL || '/sso';

export const gatewayRequest = (dispatch, path, jwtToken, body, successCallback, errorCallback, method = 'POST') => {
    const options = {
        method,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${jwtToken}`,
        },
    };
    if (method !== 'GET' && body) {
        options.body = JSON.stringify(body);
    }

    window.fetch(`${gatewayBaseUrl}${path}`, options)
        .then(response => response.json())
        .then(data => {
            if (successCallback) {
                successCallback(data);
            }
        })
        .catch(error => {
            if (errorCallback) {
                errorCallback(error);
            } else {
                console.error('Gateway request error', error);
            }
        });
};

export const ssoRequest = (dispatch, path, formData, successCallback, errorCallback) => {
    // Convert FormData to URLSearchParams to avoid multipart encoding issues
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
        params.append(key, value);
    }
    window.fetch(`${ssoBaseUrl}${path}`, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params,
        credentials: 'include',
    })
        .then(response => response.json())
        .then(data => {
            if (successCallback) successCallback(data);
        })
        .catch(error => {
            if (errorCallback) {
                errorCallback(error);
            } else {
                console.error('SSO request error', error);
            }
        });
};
